import { GlAlert } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
import { __ } from '~/locale';
export default {
    name: 'DiagramPerformanceWarning',
    i18n: {
        bodyText: __('Warning: Displaying this diagram might cause performance issues on this page.'),
        buttonText: __('Display')
    },
    components: {
        GlAlert
    },
    emits: [
        'close-alert',
        'show-image'
    ]
};
